module.exports = __webpack_public_path__ + "img/3-4.a87a9008.png";